module.exports = __webpack_public_path__ + "img/loading.bd735cc4.svg";